<mat-list>
  <a mat-list-item [routerLink]="['summary']" [routerLinkActive]="['active']"> Plant Summary </a>
  <a mat-list-item [routerLink]="['configuration']" [routerLinkActive]="['active']"> Configuration</a>
</mat-list>